var React = require('react');

function Tele (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3.5","y":"3","width":"18","height":"13","rx":"1","stroke":"white","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"8.5","y1":"21","x2":"16.5","y2":"21","stroke":"white","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M12.5 16L12.5 20","stroke":"white","strokeWidth":"2","key":2})]);
}

Tele.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = Tele;

Tele.default = Tele;
